//       MOBILE   |   TABLET    |     DESKTOP
//  |-------------|-------------|---------------
//  0             48            75
//  ZERO          M             L
//  0             768           1200
import { BREAKPOINTS } from './breakpoints';
const pxToRem = (px) => px / 16;
const MOBILE = {
    max: `${BREAKPOINTS.M - pxToRem(1)}rem`,
};
const TABLET = {
    min: `${BREAKPOINTS.M}rem`,
    max: `${BREAKPOINTS.L - pxToRem(1)}rem`,
};
const DESKTOP = {
    min: `${BREAKPOINTS.L}rem`,
};
export const MEDIA_QUERIES = {
    onlyDesktop: `@media (min-width: ${DESKTOP.min})`,
    tabletAndDesktop: `@media (min-width: ${TABLET.min})`,
    onlyTablet: `@media (max-width: ${TABLET.max}) and (min-width: ${TABLET.min})`,
    mobileAndTablet: `@media (max-width: ${TABLET.max})`,
    onlyMobile: `@media (max-width: ${MOBILE.max})`,
    // values for js mediaqueries
    matchMedia: {
        onlyDesktop: `(min-width: ${DESKTOP.min})`,
        onlyTablet: `(max-width: ${TABLET.max}) and (min-width: ${TABLET.min})`,
        onlyMobile: `(max-width: ${MOBILE.max})`,
    },
};
//# sourceMappingURL=mediaQueries.js.map